/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserAndBusinessLicenseInfoVo } from './UserAndBusinessLicenseInfoVo';
import {
    UserAndBusinessLicenseInfoVoFromJSON,
    UserAndBusinessLicenseInfoVoFromJSONTyped,
    UserAndBusinessLicenseInfoVoToJSON,
    UserAndBusinessLicenseInfoVoToJSONTyped,
} from './UserAndBusinessLicenseInfoVo';

/**
 * 
 * @export
 * @interface ResponseUserAndBusinessLicenseInfoVo
 */
export interface ResponseUserAndBusinessLicenseInfoVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseUserAndBusinessLicenseInfoVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseUserAndBusinessLicenseInfoVo
     */
    message?: string;
    /**
     * 
     * @type {UserAndBusinessLicenseInfoVo}
     * @memberof ResponseUserAndBusinessLicenseInfoVo
     */
    data?: UserAndBusinessLicenseInfoVo;
}

/**
 * Check if a given object implements the ResponseUserAndBusinessLicenseInfoVo interface.
 */
export function instanceOfResponseUserAndBusinessLicenseInfoVo(value: object): value is ResponseUserAndBusinessLicenseInfoVo {
    return true;
}

export function ResponseUserAndBusinessLicenseInfoVoFromJSON(json: any): ResponseUserAndBusinessLicenseInfoVo {
    return ResponseUserAndBusinessLicenseInfoVoFromJSONTyped(json, false);
}

export function ResponseUserAndBusinessLicenseInfoVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseUserAndBusinessLicenseInfoVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : UserAndBusinessLicenseInfoVoFromJSON(json['data']),
    };
}

export function ResponseUserAndBusinessLicenseInfoVoToJSON(json: any): ResponseUserAndBusinessLicenseInfoVo {
    return ResponseUserAndBusinessLicenseInfoVoToJSONTyped(json, false);
}

export function ResponseUserAndBusinessLicenseInfoVoToJSONTyped(value?: ResponseUserAndBusinessLicenseInfoVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': UserAndBusinessLicenseInfoVoToJSON(value['data']),
    };
}

